/**
 * The one syncer instance for the app.
 *
 * A single instance matters: the poll timer, the in-flight guard, and the status
 * subscribers all assume they are looking at the same queue. Creating a second
 * one would double-poll and could race two flushes against the same entries.
 */

import { SalesSyncer } from './syncer';

/**
 * Whether the current session may sync. A false answer withholds syncing while
 * the till keeps selling; see SalesSyncer.flush.
 */
let sessionLive: () => boolean = () => false;

export const syncer = new SalesSyncer(() => sessionLive());

/** Point the syncer at the current session's liveness. Called once by App. */
export function setSyncSessionReader(reader: () => boolean): void {
  sessionLive = reader;
}
